﻿import {useCallback, useEffect, useRef, useState} from "react";

export type RemoteData<T, Args extends any[]> =
	| { loading: true; data: undefined, refresh:(...newArgs: Args) => void }
	| { loading: false; data: T, refresh:(...newArgs: Args) => void };

export function useRemoteData<T, Args extends any[]>(factory: (...args: Args) => Promise<T>, ...initialArgs: Args): RemoteData<T, Args> {
	const [data, setData] = useState<T | undefined>(undefined);
	const [loading, setLoading] = useState(true);
	const storeRef = useRef<Promise<T> | null>(null);

	const refresh = useCallback((...newArgs: Args) => {
		setLoading(true);
		const promise = storeRef.current = factory(...newArgs);
		promise.then(value => {
			if (promise === storeRef.current) {
				setLoading(false);
				setData(value);
			}
		});
	}, [factory]);

	useEffect(() => {
		if (storeRef.current == null) {
			refresh(...initialArgs);
		}
	}, []);

	return loading ? {loading: true, data: undefined, refresh} : {loading: false, data: data as T, refresh};
}
